// Musculoskeletal subsection form field enum
export enum MusculoskeletalFormField {
  MUSCULOSKELETAL_MUSCULOSKELETAL_ASSESSMENT = 'medicalBackground/musculoskeletal/musculoskeletalAssessment',
  MUSCULOSKELETAL_SYSTEM_SUMMARY = 'medicalBackground/musculoskeletal/systemSummary'
}
